// list of constraints which will require a validate phone request to validate.
const PHONE_CONSTRAINT_NAMES = [
  'phone',
  'phone_work',
  'phone_mobile',
  'phoneInternational',
  'gbpingphone',
  'telephone',
  'mobile_phone',
];

export default PHONE_CONSTRAINT_NAMES;
